import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getSpecialtyBenefitType } from 'api/Codes';

import { useInfiniteFetchData } from 'lib/hooks/useInfiniteFetchData';

export const useSpecialtyCodes = ({ params = {}, options = {}, dependencies = [] } = {}) => {
  const navigate = useNavigate();
  return useQuery(
    ['getSpecialtyCodes', ...dependencies],
    () => getSpecialtyBenefitType(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 5000,
      ...options
    }
  );
};

export const useInfiniteSpecialtyCodes = ({ params = {}, options = {}, dependencies = [] } = {}) => {
  return useInfiniteFetchData({
    queryKey: 'benefit_type_code',
    url: '/api/codes/benefit_type_code/get',
    params: {
      limit: 25,
      page: 1,
      withCount: true,
      ...params
    },
    dependencies,
    options: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...options
    }
  });
};
